module.exports = __webpack_public_path__ + "img/sub.ca1968f4.png";